/**
 * Apri i link esterni in una nuova finestra
 * -----------------------------------------------------------------------------
 * Aggiunge automaticamente target="_blank" e rel="noopener noreferrer" a tutti i link esterni.
 */
document.addEventListener('DOMContentLoaded', function () {
  console.log('Script per i link esterni caricato correttamente');

  function setExternalLinksNewTab(selector) {
    document.querySelectorAll(selector).forEach(link => {
      if (link.href.startsWith('http') && !link.href.includes(window.location.hostname)) {
        console.log('Link Esterno Modificato:', link.href);
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
        link.addEventListener('click', function (e) {
          e.preventDefault();
          window.open(link.href, '_blank', 'noopener,noreferrer');
        });
      } else {
        console.log('Link Interno Ignorato:', link.href);
      }
    });
  }

  // Applica ai link globali
  setExternalLinksNewTab('a[href^="http"]');

  // Applica ai link specifici del menu
  setExternalLinksNewTab('#accordion3 > li:nth-child(1) > a[href^="http"]');
  setExternalLinksNewTab('#accordion3 a[href^="http"]'); // Per tutti i link nel menu

  // Monitoraggio del DOM per nuovi link dinamici
  const observer = new MutationObserver(() => {
    console.log('MutationObserver: rilevato un cambiamento nel DOM');
    setExternalLinksNewTab('#accordion3 > li:nth-child(1) > a[href^="http"]');
    setExternalLinksNewTab('#accordion3 a[href^="http"]');
  });

  observer.observe(document.body, { childList: true, subtree: true });
});